import { heroChips, heroStats } from "@/mocks/home";

export default function Hero() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full flex items-center min-h-[580px] lg:min-h-[700px]">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20impressionist%20painting%20of%20a%20quiet%20warm-toned%20music%20room%20at%20dusk%20with%20a%20grand%20piano%20silhouette%2C%20soft%20floating%20sheet%20music%20pages%2C%20muted%20terracotta%20and%20ochre%20brushstrokes%2C%20deep%20warm%20shadows%2C%20painterly%20texture%2C%20cinematic%20empty%20negative%20space%20in%20the%20upper%20area%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-yuewan-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85" />
      </div>

      <div className="relative z-10 w-full max-w-content mx-auto px-4 md:px-6 pt-28 pb-14 md:pt-32 md:pb-20 animate-fade-up">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs tracking-wide backdrop-blur-sm">
          <i className="ri-music-2-line" />
          内容合辑 · 家庭成长向阅读场景
        </span>

        <h1 className="mt-5 font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight max-w-4xl">
          年轻的岳母 · 漫画、小说、同人与本子的阅读场景
        </h1>

        <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
          这里汇集《年轻的岳母》相关的漫画、小说、同人创作与番外本子资源说明，并提供
          <strong className="font-semibold text-background-50"> 无翼鸟 </strong>
          等热门专题入口的内容范围介绍。无论你是想追更主线剧情，还是寻找同人衍生创作，都能在这一页里找到对应的作品定位、卷章脉络与最新更新记录。
        </p>

        <div className="mt-6 flex flex-wrap gap-2">
          {heroChips.map((chip) => (
            <span
              key={chip}
              className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-foreground-950/30 border border-background-50/20 whitespace-nowrap"
            >
              {chip}
            </span>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={() => goTo("overview")}
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            先看作品速览
            <i className="ri-arrow-down-line" />
          </button>
          <button
            type="button"
            onClick={() => goTo("story")}
            className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/35 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors backdrop-blur-sm"
          >
            <i className="ri-list-ordered" />
            查看卷章脉络
          </button>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
          {heroStats.map((stat) => (
            <div key={stat.label} className="border-l border-background-50/25 pl-4">
              <div className="font-heading text-2xl md:text-3xl font-semibold text-background-50">
                {stat.value}
                <span className="text-accent-400 text-lg md:text-xl">{stat.suffix}</span>
              </div>
              <div className="mt-1 text-xs md:text-sm text-background-200">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}